import {Box, Flex} from 'exsportia-components'
import {FC} from 'react'

type Props = {
  currentStep: 1 | 2 | 3 | 4
}

export const PhoneLoginProgress: FC<Props> = ({currentStep}) => {
  return (
    <Flex
      width='100%'
      gap='4px'
      mb='24px'
    >
      {[1, 2, 3, 4].map((step) => (
        <Box
          key={`progress-bar-${step}`}
          flex={1}
          height='3px'
          borderRadius='1px'
          backgroundColor={step <= currentStep ? '#ED3163' : 'rgba(0, 16, 61, 0.12)'}
        />
      ))}
    </Flex>
  )
}
